type Method = 'reset' | 'page' | 'identify' | 'alias' | 'track';

export const createAnalyticsTracker =
  (debug: boolean) =>
  (
    method: Method,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ...contextArgs: any[]
  ) => {
    if (debug) {
      // eslint-disable-next-line no-console
      console.log(`analyticsTracker.${method}:`, ...contextArgs);
    }

    if (global.rudderanalytics) {
      const mixpanelCookie = document.cookie.match(/ajs_distinct_id=[^;]*/g);
      let distinctId = '';
      if (mixpanelCookie) {
        distinctId = mixpanelCookie[0].replace('ajs_distinct_id=', '');
      }

      if (distinctId !== '') {
        global.rudderanalytics.setAnonymousId(distinctId);
      }

      global.rudderanalytics[method](...contextArgs);
    }
  };
